/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_SubtitleInputs */

const bn_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেশ অনুমান খেলা`)
};

const de_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Länder-Ratespiel`)
};

const el_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το παιχνίδι εικασίας της χώρας`)
};

const en_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The country guessing game`)
};

const es_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El juego de adivinar el país`)
};

const fr_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le jeu de devinettes de pays`)
};

const hi_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देश अनुमान लगाने का खेल`)
};

const hu_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az ország tippelő játék`)
};

const id_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan tebak-tebakan negara`)
};

const it_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gioco d'ipotesi del paese`)
};

const ja_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国当てゲーム`)
};

const ko_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나라 추측 게임`)
};

const nl_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het landraadspel`)
};

const pl_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gra w zgadywanie kraju`)
};

const pt_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O jogo de adivinhação do país`)
};

const ru_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страна-угадайка`)
};

const sv_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landets gissningslek`)
};

const tr_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülke tahmin etme oyunu`)
};

const uk_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гра «Вгадай країну».`)
};

const vi_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trò chơi đoán đất nước`)
};

const zh_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜国家游戏`)
};

const zh_hant_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜國家遊戲`)
};

/**
* | output |
* | --- |
* | "The country guessing game" |
*
* @param {App_SubtitleInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const app_subtitle = /** @type {((inputs?: App_SubtitleInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_SubtitleInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_app_subtitle(inputs)
	if (locale === "de") return de_app_subtitle(inputs)
	if (locale === "el") return el_app_subtitle(inputs)
	if (locale === "en") return en_app_subtitle(inputs)
	if (locale === "es") return es_app_subtitle(inputs)
	if (locale === "fr") return fr_app_subtitle(inputs)
	if (locale === "hi") return hi_app_subtitle(inputs)
	if (locale === "hu") return hu_app_subtitle(inputs)
	if (locale === "id") return id_app_subtitle(inputs)
	if (locale === "it") return it_app_subtitle(inputs)
	if (locale === "ja") return ja_app_subtitle(inputs)
	if (locale === "ko") return ko_app_subtitle(inputs)
	if (locale === "nl") return nl_app_subtitle(inputs)
	if (locale === "pl") return pl_app_subtitle(inputs)
	if (locale === "pt") return pt_app_subtitle(inputs)
	if (locale === "ru") return ru_app_subtitle(inputs)
	if (locale === "sv") return sv_app_subtitle(inputs)
	if (locale === "tr") return tr_app_subtitle(inputs)
	if (locale === "uk") return uk_app_subtitle(inputs)
	if (locale === "vi") return vi_app_subtitle(inputs)
	if (locale === "zh") return zh_app_subtitle(inputs)
	return zh_hant_app_subtitle(inputs)
});